export const BackgroundColor = "#D5DCE9"
export const PrimaryColor = "#003469"
export const Font = "sans-serif"